const timezones = [
  {
    optionKey: "UTC-08:00 Pacific Standard Time",
    optionValue: "UTC-08:00 Pacific Standard Time",
  },
  {
    optionKey: "UTC-07:00 Mountain Standard Time",
    optionValue: "UTC-07:00 Mountain Standard Time",
  },
  {
    optionKey: "UTC-06:00 Central Standard Time",
    optionValue: "UTC-06:00 Central Standard Time",
  },
  {
    optionKey: "UTC-05:00 Eastern Standard Time",
    optionValue: "UTC-05:00 Eastern Standard Time",
  },
  {
    optionKey: "UTC-04:00 Atlantic Standard Time",
    optionValue: "UTC-04:00 Atlantic Standard Time",
  },
  {
    optionKey: "UTC-03:00 Argentina Time",
    optionValue: "UTC-03:00 Argentina Time",
  },
  {
    optionKey: "UTC-02:00 South Georgia Time",
    optionValue: "UTC-02:00 South Georgia Time",
  },
  {
    optionKey: "UTC-01:00 Cape Verde Time",
    optionValue: "UTC-01:00 Cape Verde Time",
  },
  {
    optionKey: "UTC+00:00 Coordinated Universal Time",
    optionValue: "UTC+00:00 Coordinated Universal Time",
  },
  {
    optionKey: "UTC+00:00 Greenwich Mean Time",
    optionValue: "UTC+00:00 Greenwich Mean Time",
  },
  {
    optionKey: "UTC+01:00 Central European Time",
    optionValue: "UTC+01:00 Central European Time",
  },
  {
    optionKey: "UTC+01:00 West Africa Time",
    optionValue: "UTC+01:00 West Africa Time",
  },
  {
    optionKey: "UTC+02:00 Central Africa Time",
    optionValue: "UTC+02:00 Central Africa Time",
  },
  {
    optionKey: "UTC+02:00 Eastern European Time",
    optionValue: "UTC+02:00 Eastern European Time",
  },
  {
    optionKey: "UTC+02:00 South Africa Standard Time",
    optionValue: "UTC+02:00 South Africa Standard Time",
  },
  {
    optionKey: "UTC+03:00 East Africa Time",
    optionValue: "UTC+03:00 East Africa Time",
  },
  {
    optionKey: "UTC+03:00 Moscow Standard Time",
    optionValue: "UTC+03:00 Moscow Standard Time",
  },
  {
    optionKey: "UTC+03:30 Iran Standard Time",
    optionValue: "UTC+03:30 Iran Standard Time",
  },
  {
    optionKey: "UTC+03:30 Tehran Time",
    optionValue: "UTC+03:30 Tehran Time",
  },
  {
    optionKey: "UTC+04:00 Gulf Standard Time",
    optionValue: "UTC+04:00 Gulf Standard Time",
  },
  {
    optionKey: "UTC+04:30 Afghanistan Time",
    optionValue: "UTC+04:30 Afghanistan Time",
  },
  {
    optionKey: "UTC+05:00 Pakistan Standard Time",
    optionValue: "UTC+05:00 Pakistan Standard Time",
  },
  {
    optionKey: "UTC+05:30 Indian Standard Time",
    optionValue: "UTC+05:30 Indian Standard Time",
  },
  {
    optionKey: "UTC+05:45 Nepal Time",
    optionValue: "UTC+05:45 Nepal Time",
  },
  {
    optionKey: "UTC+06:00 Bangladesh Standard Time",
    optionValue: "UTC+06:00 Bangladesh Standard Time",
  },
  {
    optionKey: "UTC+06:30 Myanmar Time",
    optionValue: "UTC+06:30 Myanmar Time",
  },
  {
    optionKey: "UTC+07:00 Bangkok Time",
    optionValue: "UTC+07:00 Bangkok Time",
  },
  {
    optionKey: "UTC+07:00 Indochina Time",
    optionValue: "UTC+07:00 Indochina Time",
  },
  {
    optionKey: "UTC+08:00 China Standard Time",
    optionValue: "UTC+08:00 China Standard Time",
  },
  {
    optionKey: "UTC+08:00 Singapore Time",
    optionValue: "UTC+08:00 Singapore Time",
  },
  {
    optionKey: "UTC+08:00 Western Australian Standard Time",
    optionValue: "UTC+08:00 Western Australian Standard Time",
  },
  {
    optionKey: "UTC+08:30 Pyongyang Time",
    optionValue: "UTC+08:30 Pyongyang Time",
  },
  {
    optionKey: "UTC+09:00 Japan Standard Time",
    optionValue: "UTC+09:00 Japan Standard Time",
  },
  {
    optionKey: "UTC+09:00 Korean Standard Time",
    optionValue: "UTC+09:00 Korean Standard Time",
  },
  {
    optionKey: "UTC+09:30 Australian Central Standard Time",
    optionValue: "UTC+09:30 Australian Central Standard Time",
  },
  {
    optionKey: "UTC+10:00 Australian Eastern Standard Time",
    optionValue: "UTC+10:00 Australian Eastern Standard Time",
  },
  {
    optionKey: "UTC+10:30 Lord Howe Island Time",
    optionValue: "UTC+10:30 Lord Howe Island Time",
  },
  {
    optionKey: "UTC+11:00 Australian Eastern Daylight Time",
    optionValue: "UTC+11:00 Australian Eastern Daylight Time",
  },
  {
    optionKey: "UTC+12:00 Fiji Time",
    optionValue: "UTC+12:00 Fiji Time",
  },
  {
    optionKey: "UTC+12:45 Chatham Islands Time",
    optionValue: "UTC+12:45 Chatham Islands Time",
  },
  {
    optionKey: "UTC+13:00 New Zealand Daylight Time",
    optionValue: "UTC+13:00 New Zealand Daylight Time",
  },
];

export default timezones;